<style lang="less" scoped>
.main-container {
  width: 100%;
  height: 100%;
  background: #fff;
  // .left-logo-menu-div {
  //     // width: 329px;
  //     height: 100%;
  //     overflow-y: auto;
  //     overflow-x: hidden;
  //     // background: #4182EB;
  //     margin-right: 2px;
  //     // background-image: url('../assets/main/left-bg.png');
  //     // background-size: 100% 100%;
  //     display: flex;
  //     flex-direction: column;
  // }
  // .left-small-menu-div {
  //     width: 121px;
  //     background-image: url('../assets/main/left-small-menu-bg.png');
  //     .menu-collpose-div {
  //         margin-top: 24px;
  //         height: 56px;
  //         display: flex;
  //         align-items: center;
  //         cursor: pointer;
  //         margin-left: 26px;
  //     }
  // }
  // .left-logo-menu-div::-webkit-scrollbar {
  //     width: 0;
  // }
  .right-bar-content-div {
    overflow-y: auto;
    .header-container-user {
      width: 100%;
      height: 335px;
      text-align: right;
      line-height: 75px;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(90deg, #4182eb, #67bcfb);
      .pro-title-div {
        width: 100%;
        margin-right: 30px;
        height: 75px;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        border-bottom: 1px solid #d4d2cf;
        // margin-bottom: 16px;

        .left-close-icon {
          height: 60px;
          width: 135px;
          box-sizing: border-box;
          margin-left: 30px;
          margin-top: 5px;
          // font-size: 18px;
          // color: #364166;
          // cursor: pointer;
        }
        .right-title-div {
          margin-left: 15px;
          height: 75px;
          line-height: 75px;
          font-size: 26px;
          font-weight: 600;
          color: #ffffff;
        }
      }
      // margin-left: 50px;

      // padding-right: 50px;
      .flex-x-end {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;

        -webkit-box-orient: horizontal;
        -webkit-flex-direction: row;
        flex-direction: row;

        -webkit-box-pack: flex-end;
        -webkit-justify-content: flex-end;
        -ms-flex-pack: flex-end;
        justify-content: flex-end;
      }
      .align-center {
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        -ms-grid-row-align: center;
        align-items: center;
      }
      .header-container-img {
        width: 25px;
        height: 29px;
        // border-radius: 50%;
        overflow: hidden;
        margin-right: 30px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .user-icon-container {
        width: 55px;
        height: 55px;
        // padding: 3px 4px 0 0 ;
        // border-radius: 50%;
        // background-color: #4182EB;
        overflow: hidden;
        i {
          font-size: 26px;
          line-height: 26px;
          color: #ffffff;
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .header-container-name {
        font-size: 16px;
        color: #ffffff;
        margin: 0 10px;
      }
      .header-container-down {
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #ffffff;
      }
    }
    // .left-settings-div {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: right;
    //     height: 75px;
    //     line-height: 75px;
    //     background: #fff;
    //     margin-left: -45px;
    //     // margin: 32px 20px;
    //     .user-info-div {
    //         // margin-bottom: 16px;
    //         .left-user-icon-div{
    //             width: 25px;
    //             height: 25px;
    //         }
    //         .right-title-div {
    //             font-size: 16px;
    //             font-weight: 400;
    //             color: #364166;
    //             line-height: 75px;
    //             margin-left: 40px;
    //         }
    //     }
    //     .setting-child-div {
    //         .left-icon-div {
    //             width: 40px;
    //             height: 32px;
    //             display: flex;
    //             justify-content: center;
    //             align-items: center;
    //         }
    //         .right-title-div {
    //             font-size: 14px;
    //             font-weight: 400;
    //             color: #364166;
    //             line-height: 75px;
    //             margin-left: 40px;
    //             cursor: pointer;
    //         }
    //     }
    // }
    .action-btns-div {
      width: 100%;
      height: 64px;
      background: rgba(62, 174, 232, 1);
      border: 0;
      .user-logout-div {
        margin-right: 32px;
        cursor: pointer;
        .user-icon-div {
          margin-right: 8px;
        }
        .down-icon-div {
          margin-left: 8px;
        }
        .user-name-div {
          font-size: 14px;
          color: #fff;
        }
      }
    }
    .center-line-div {
      width: 100%;
      height: 1px;
      background: #51b8ee;
    }
    .bread-crumb-div {
      width: 100%;
      height: 64px;
      background: rgba(62, 174, 232, 1);
    }
    .content-view-div {
      margin: 0 auto;
      width: 1280px;
      // height: 100%;
      display: flex;
      flex-wrap: wrap;
      // justify-content: center;
      position: absolute;
      top: 200px;
      left: 23%;
      .menu_item {
        width: 257px;
        height: 257px;
        position: relative;
        top: 0;
        left: 0;
        margin-bottom: 20px;
        .menu_item_name {
          width: 257px;
          text-align: center;
          position: absolute;
          bottom: 20px;
          left: 7px;
          color: #030303;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
      }
    }
  }
}
</style>

<template>
  <div class="main-container flex">
    <div class="right-bar-content-div flex-1">
      <div class="header-container-user flex-grow-0 c-pointer">
        <div class="pro-title-div flex">
          <div class="left-close-icon">
            <img src="../assets/main/logo-row.png" width="100%" height="100%" />
          </div>
          <!-- <div class="right-title-div">挚达</div> -->
          <div class="flex-grow-1"></div>
          <el-dropdown
            class="header-dropdown margin-r-30"
            @command="handleCommand"
          >
            <div class="flex-x-end align-center">
              <div class="header-container-img">
                <img src="../assets/main/notice-white.png" />
              </div>
              <div class="user-icon-container">
                <img src="../assets/main/manager-black.png" />
                <!-- <i class="el-icon-s-custom"></i> -->
              </div>
              <p class="header-container-name">{{ userName }}</p>
              <img src="../assets/main/down.png" alt="" />
              <!-- <i class="header-container-down"></i> -->
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="01">密码修改</el-dropdown-item>
              <el-dropdown-item command="02" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="content-view-div">
        <div
          v-for="item in mainmenuList"
          :key="item.menuCode"
          class="menu_item"
          @click="toMenu(item)"
        >
          <img :src="item.backImg" alt="" />
          <div class="menu_item_name">{{ item.menuName }}</div>
        </div>
      </div>
    </div>
    <!-- 密码重置 -->
    <el-dialog title="密码重置" width="520px" :visible.sync="popup.show">
      <el-form :model="popup.formInfo" ref="pwdResetRef" :rules="popup.rules">
        <el-form-item label="输入密码" prop="restPassWord">
          <el-input
            clearable
            v-model="popup.formInfo.restPassWord"
            type="password"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checknewPassWord">
          <el-input
            clearable
            v-model="popup.formInfo.checknewPassWord"
            type="password"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitPwdFrom('pwdResetRef')"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "@/components/menu/index.vue";
import chargeImg from "../assets/main/charge-back.png";
import userImg from "../assets/main/user-back.png";
import orderImg from "../assets/main/order-back.png";
import operationImg from "../assets/main/operation-back.png";

import runImg from "../assets/main/run-back.png";
import systemImg from "../assets/main/system-back.png";
import basicImg from "../assets/main/basic-back.png";
export default {
  components: {
    Menu,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.popup.formInfo.restPassWord) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      menuCollposed: false,
      userName: "",
      isSupertube: false,
      // menuList:[],
      mainmenuList: [],
      curMainMenuList: [],
      popup: {
        formInfo: {},
        show: false,
        rules: {
          restPassWord: [
            {
              required: true,
              message: "请输入新密码",
              trigger: "blur",
            },
            {
              required: true,
              message: "请输入8位及以上包含大小写字母、数字、特殊字符",
              trigger: "blur",
              pattern: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/, // 与app端同步的客户密码正则
            }
          ],
          checknewPassWord: [
            {
              required: true,
              validator: validatePass,
              trigger: "blur",
            },
            {
              required: true,
              message: "请输入8位及以上包含大小写字母、数字、特殊字符",
              trigger: "blur",
              pattern: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/, // 与app端同步的客户密码正则
            }
          ],
        },
      },
      gsMenuList: [
        {
          menuCode: "1",
          backImg: chargeImg,
          menuName: "充电设备管理",
          menuNameEn: "",
        },
        {
          menuCode: "2",
          backImg: userImg,
          menuName: "用户信息管理",
        },
        {
          menuCode: "3",
          backImg: orderImg,
          menuName: "订单管理",
        },
        // {
        //     menuCode:'4',
        //     backImg:operationImg,
        //     menuName:'运维管理'
        // },
        // {
        //     menuCode:'5',
        //     backImg:runImg,
        //     menuName:'运营管理'
        // },
        {
          menuCode: "6",
          backImg: systemImg,
          menuName: "基础信息管理",
        },
        {
          menuCode: "7",
          backImg: operationImg,
          menuName: "设备升级",
        },
        // {
        //   menuCode: "8",
        //   backImg: runImg,
        //   menuName: "运营分析",
        // },
        {
          menuCode: "8",
          backImg: runImg,
          menuName: "运营配置",
        },
        {
          menuCode: "9",
          backImg: basicImg,
          menuName: "个人站运营管理",
        },
        {
          menuCode: "10",
          backImg: operationImg,
          menuName: "营销活动",
        },
      ],
      cgMenuList: [
        {
          menuCode: "1",
          backImg: basicImg,
          menuName: "基础信息配置",
        },
      ],
    };
  },
  methods: {
    init() {
      this.curMainMenuList = this.$store.state.curMainMenuList || [];
      this.mainmenuList = [];
      let list = this.isSupertube ? this.cgMenuList : this.gsMenuList;
      list.forEach((item, index) => {
        if (this.curMainMenuList.indexOf(item.menuName) > -1) {
          this.mainmenuList.push(item);
        }
      });
      console.log(this.mainmenuList);
      this.$store.commit("updateCurMenuListList", []);
      this.userName = this.$store.state.userInfo.userName;
    },
    /* 修改密码 && 退出登录 */
    handleCommand(val) {
      if (val == "01") {
        this.popup.formInfo = {
          newPassWord: "",
          checknewPassWord: "",
        };
        this.popup.show = true;
      } else if (val == "02") {
        this.logoutFun();
      }
    },
    //密码提交
    submitPwdFrom(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            restPassWord: _.popup.formInfo.restPassWord,
            userId: _.$store.state.userInfo.userId,
          };
          _.$H.post(_, _.$A.user.userPwdReset, obj).then((res) => {
            _.$U.success("修改成功");
            _.popup.show = false;
            _.logoutFun();
          });
        }
      });
    },
    logoutFun() {
      this.$store.commit("setToken", "");
      this.$router.replace("/");
    },
    cancel() {
      this.popup.show = false;
      this.popup.formInfo = {};
    },
    toMenu(menu) {
      console.log(this.menuList, menu)
      let menuArr = this.menuList.filter(
        (item) => item.meta.title == menu.menuName
      );
      this.$store.commit("updateCurMenuListList", menuArr);
      if (!menuArr[0]) return;
      let path = "";

      if (menuArr[0].children && menuArr[0].children.length > 0) {
        path = this.loop(menuArr[0].children);
      } else {
        path = menuArr[0].name;
      }
      if (!path) return;
      this.$router.push({
        name: path,
      });
    },
    loop(children) {
      const canUse = (routeName) => {
        if (!routeName) return false;
        const checker = this.$S?.checkUserMenu;
        return typeof checker === "function" ? checker(routeName) : true;
      };

      const dfs = (nodes) => {
        if (!Array.isArray(nodes)) return "";
        for (const n of nodes) {
          if (!n) continue;
          if (Array.isArray(n.children) && n.children.length > 0) {
            const found = dfs(n.children);
            if (found) return found;
          } else if (canUse(n.name)) {
            return n.name;
          }
        }
        return "";
      };

      // 优先返回第一个“有权限”的叶子路由，避免跳到无权限的默认页面
      const authorized = dfs(children);
      if (authorized) return authorized;

      // 兜底：仍按原逻辑取第一个可用节点
      return Array.isArray(children) && children[0] ? (children[0].children?.[0]?.name || children[0].name || "") : "";
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    getUserName() {
      return this.$store.state.userInfo.userName;
    },
    menuList() {
      return this.$store.state.menuList || [];
    },
  },
};
</script>
